import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ConfigurationService } from '@core';
import { DigitsGroupingPipe } from '../pipes';

@Component({
  selector: 'lib-cart-old-price',
  templateUrl: './cart-old-price.component.html',
  styleUrls: ['./cart-old-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DigitsGroupingPipe],
})
export class CartOldPriceComponent {
  protected readonly rewardName = inject(ConfigurationService).rewardName;
  readonly price = input<number | null>();

  readonly inline = input<boolean>();
}
